module.exports = __webpack_public_path__ + "img/icon-exchange.48fc2b9b.svg";